export const TRANSIT_OPERATION_AUDIT_KEY = 'transit-operation-audit'

export const transitOperationAuditQueryKeys = {
  all: () => TRANSIT_OPERATION_AUDIT_KEY,
}
